import { AutocompleteWithLabel, InputWithLabel } from '@adotel/components'
import SearchIcon from '@material-ui/icons/Search'
import { matchSorter } from 'match-sorter'
import React, { useEffect, useState } from 'react'

import { getTranslate } from '../../localization'
import { Accommodation } from '../../types/accommodation'
import { Tenant } from '../../types/tenants'
import useStyles from './styles/providerFilters.styles'

interface ProviderFiltersProps {
  tenants: Tenant[] | undefined
  accommodations: Accommodation[] | undefined
  loadingForTenant: boolean
  autoCompleteTenantValue: any
  setAutoCompleteTenantValue: React.Dispatch<any>
  accommodationList: Accommodation[]
  setAccommodationList: React.Dispatch<React.SetStateAction<Accommodation[]>>
  setFilteredAccommodationList: React.Dispatch<
    React.SetStateAction<Accommodation[]>
  >
}
const ProviderFilters: React.FC<ProviderFiltersProps> = ({
  tenants,
  accommodations,
  loadingForTenant,
  autoCompleteTenantValue,
  setAutoCompleteTenantValue,
  accommodationList,
  setAccommodationList,
  setFilteredAccommodationList
}) => {
  const classes = useStyles()
  const [searchInputValue, setSearchInputValue] = useState<string>('')

  useEffect(() => {
    if (autoCompleteTenantValue) {
      setAccommodationList(
        (accommodations &&
          accommodations
            .filter(
              (ele) =>
                ele.basicDetails.displayTenantCode ===
                autoCompleteTenantValue.code
            )
            .map((acc) => ({ ...acc, checked: false }))) ||
          []
      )
    }
  }, [autoCompleteTenantValue, accommodations])

  useEffect(() => {
    const fullAccommodationList = accommodationList
    const newFilteredAccommodations = matchSorter(
      fullAccommodationList,
      searchInputValue,
      {
        keys: [
          'basicDetails.name',
          {
            key: 'basicDetails.propertyCode',
            threshold: matchSorter.rankings.STARTS_WITH
          }
        ]
      }
    )

    // Create a map of original indexes
    const indexMap = new Map()
    fullAccommodationList.forEach((item, index) => {
      indexMap.set(item, index)
    })

    // Sort the filtered list based on the original indexes
    const sortedFilteredAccommodations = newFilteredAccommodations.sort(
      (a, b) => {
        const indexA = indexMap.get(a)
        const indexB = indexMap.get(b)
        return indexA - indexB
      }
    )

    setFilteredAccommodationList(sortedFilteredAccommodations)
  }, [searchInputValue, accommodationList, accommodations])

  return (
    <div className={classes.root}>
      <InputWithLabel
        placeholder={getTranslate('Search by Accommodation Name')}
        autoComplete="off"
        noHelperText
        fullWidth
        startIcon={<SearchIcon />}
        className={classes.searchInput}
        value={searchInputValue}
        onChange={(e) => setSearchInputValue(e.currentTarget.value)}
        inputSize="small"
      />
      <div className={classes.selectorContainer}>
        <AutocompleteWithLabel
          noHelperText
          fullWidth
          value={autoCompleteTenantValue}
          label={getTranslate('Tenants')}
          placeholder={getTranslate('Choose Tenant')}
          options={
            tenants?.map((item) => ({
              label: item.basicDetails.name,
              value: item.basicDetails.tenantId || '',
              code: item.basicDetails.displayTenantCode
            })) || []
          }
          onChange={(_, v: any) => {
            if (v) {
              setAutoCompleteTenantValue({
                value: v.value,
                label: v.label,
                code: v.code
              })
            } else {
              setAutoCompleteTenantValue(null)
            }
          }}
          getOptionLabel={(option) => option.label || ''}
          getOptionSelected={(option, value) => option.value === value.value}
          loading={loadingForTenant}
          loadingText={getTranslate('Loading') + '...'}
        />
      </div>
    </div>
  )
}

export default ProviderFilters
